import { createIcon } from '@chakra-ui/icons';

export const BulletList = createIcon({
  displayName: 'BulletList',
  viewBox: '0 0 12 12',
  path: [
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1044_24256)">
        <path d="M12 0.75H4.5V2.25H12V0.75Z" fill="currentColor" />
        <path d="M12 5.25H4.5V6.75H12V5.25Z" fill="currentColor" />
        <path d="M12 9.75H4.5V11.25H12V9.75Z" fill="currentColor" />
        <path
          d="M2.25 0H0.75C0.3 0 0 0.3 0 0.75V2.25C0 2.7 0.3 3 0.75 3H2.25C2.7 3 3 2.7 3 2.25V0.75C3 0.3 2.7 0 2.25 0Z"
          fill="currentColor"
        />
        <path
          d="M2.25 4.5H0.75C0.3 4.5 0 4.8 0 5.25V6.75C0 7.2 0.3 7.5 0.75 7.5H2.25C2.7 7.5 3 7.2 3 6.75V5.25C3 4.8 2.7 4.5 2.25 4.5Z"
          fill="currentColor"
        />
        <path
          d="M2.25 9H0.75C0.3 9 0 9.3 0 9.75V11.25C0 11.7 0.3 12 0.75 12H2.25C2.7 12 3 11.7 3 11.25V9.75C3 9.3 2.7 9 2.25 9Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1044_24256">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
